import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  CommonTranslations,
  ProfileTranslations,
  ItineraryTranslations,
} from "./types";
import clientI18n from "./client";
import serverI18n from "./server";

// Get initial language from localStorage if available
const getInitialLanguage = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("language") || "en";
  }
  return "en";
};

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: {
      common: CommonTranslations;
      profile: ProfileTranslations;
      itinerary: ItineraryTranslations;
    };
  }
}

// Only initialize i18n on the client side
if (typeof window !== "undefined") {
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: getInitialLanguage(),
      backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        requestOptions: {
          cache: "force-cache",
        },
      },
      fallbackLng: "en",
      supportedLngs: ["en", "zh", "ja", "es", "fr", "de", "it"],
      ns: ["common", "profile", "itinerary"],
      defaultNS: "common",
      fallbackNS: "common",
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
      },
      load: "languageOnly",
      preload: ["en"],
      partialBundledLanguages: true,
    });
} else {
  // Server-side initialization with minimal configuration
  i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "zh", "ja", "es", "fr", "de", "it"],
    ns: ["common", "profile", "itinerary"],
    defaultNS: "common",
    fallbackNS: "common",
    interpolation: {
      escapeValue: false,
    },
    // Disable backend loading on server
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      requestOptions: {
        cache: "force-cache",
      },
    },
    // Disable language detection on server
    detection: {
      order: [],
      caches: [],
    },
  });
}

export const i18nClient = clientI18n;
export const i18nServer = serverI18n;

// Export server instance as default for backward compatibility
export default serverI18n;
